import styled from 'styled-components';

import { pxToRem } from 'shared/lib/pxToRem';

export const RolesContainerStyled = styled.div`
	gap: ${pxToRem(16)};
	display: flex;
	flex-direction: column;
	margin-bottom: ${pxToRem(12)};
	width: 100%;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		gap: ${pxToRem(24)};
	}
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		flex-direction: row;
		width: ${pxToRem(812)};
	}
`;
